export default (theme) => ({
  defaultProps: {
    fullWidth: true,
  },
});
